import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";

const ELEMENT_SELECTOR = '[data-tabs-controller]';
const PLUGIN_NAME = 'tabsController';

const log = debug('tabs-controller');

class TabsController {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.tabs = this.selectors.selectTarget(
			this.options.tabsSelector,
			this.$element
		);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');
		this.$element.on('closeothers', this.closeOtherTabs.bind(this));
	}

	closeOtherTabs(event){
		const openingTab = event.target;

		const tabsToClose = this.tabs.filter(function(index, tab) {
			return tab !== openingTab;
		});

		tabsToClose.each((index, tab) => {
			tab.dataset.collapsibleOpen = false;
		});

	}
}

TabsController.DEFAULTS = {};

plugin(PLUGIN_NAME, TabsController);

// $(document).ready(() => {
// 	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
// });

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		plugin(PLUGIN_NAME, TabsController);
		$(element)[PLUGIN_NAME]();
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/tabs/tabs-controller.js